/* VitalandGlow helpers: make UGC card scale "active" based on center position */
(function(){
  function initUGC(){
    var rail = document.querySelector('[data-vag-ugc-rail]');
    if(!rail) return;

    function update(){
      var rect = rail.getBoundingClientRect();
      var center = rect.left + rect.width/2;
      var cards = rail.querySelectorAll('.vag-ugc-card');
      var best = null, bestDist = Infinity;
      cards.forEach(function(card){
        var r = card.getBoundingClientRect();
        var c = r.left + r.width/2;
        var dist = Math.abs(c-center);
        if(dist < bestDist){ bestDist = dist; best = card; }
        card.classList.remove('is-active');
      });
      if(best) best.classList.add('is-active');
    }

    rail.addEventListener('scroll', function(){ window.requestAnimationFrame(update); }, {passive:true});
    window.addEventListener('resize', update);
    update();
  }

  document.addEventListener('DOMContentLoaded', initUGC);
})();
